import { Outlet } from 'react-router'

const ElectricityBillLayout = () => {
  return (
    <Outlet />
  )
}

export default ElectricityBillLayout